import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppSistemaMedlogicModule } from './app/app-sistema-medlogic.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppSistemaMedlogicModule)
  .catch(err => console.error(err));
